module.exports = __webpack_public_path__ + "static/home-vietnam-f3e1fc61b04b657735b25ce9897656c0.jpg";